export enum UserActionReadStateEnum {
  STORY = 'STORY',
  DRAWER = 'DRAWER',
}
